import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as UserAuthActions from './user-auth.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthService } from '@core/services/auth/auth.service';

export class UserAuthEffects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);

  loadUserDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserAuthActions.loadUserDetails),
      switchMap(() =>
        this.authService.getUserProfile().pipe(
          map((response) => {
            if (response.body) {
              return UserAuthActions.loadUserDetailsSuccess({ response: response.body });
            }
            return UserAuthActions.loadUserDetailsFailure({ error: 'Response body is empty' });
          }),
          catchError((error) =>
            of(
              UserAuthActions.loadUserDetailsFailure({
                error: error?.error?.message || error?.message || 'Failed to load user details',
              })
            )
          )
        )
      )
    )
  );
}
